import { useMemo } from 'react';
import { airAmbulanceAdapter } from './airAmbulanceAdapter';

/**
 * Registered ETL resource request adapters. When you add one, list it here and
 * call its `useList` once inside `useResourceRequestRegistryLists`.
 */
export const RESOURCE_REQUEST_ADAPTERS = [airAmbulanceAdapter] as const;

export type RegisteredResourceRequestAdapter =
  (typeof RESOURCE_REQUEST_ADAPTERS)[number];

export type ResourceRequestRegistryListSlice = {
  adapter: RegisteredResourceRequestAdapter;
  requests: ReturnType<RegisteredResourceRequestAdapter['useList']>['requests'];
  isFetching: boolean;
};

/**
 * Aggregates list polling across registered adapters. Each adapter `useList`
 * runs here so hook order stays stable when the registry grows.
 */
export function useResourceRequestRegistryLists(): readonly ResourceRequestRegistryListSlice[] {
  const airAmbulanceList = airAmbulanceAdapter.useList();

  return useMemo(
    (): readonly ResourceRequestRegistryListSlice[] => [
      {
        adapter: airAmbulanceAdapter,
        requests: airAmbulanceList.requests,
        isFetching: airAmbulanceList.isFetching,
      },
    ],
    [airAmbulanceList.requests, airAmbulanceList.isFetching],
  );
}

export type {
  ResourceRequestAdapter,
  ResourceRequestBannerProps,
  ResourceRequestDetailView,
  ResourceRequestListItemProps,
  ResourceRequestPickupLocation,
  ResourceRequestQueueCategory,
} from './types';
export { airAmbulanceAdapter } from './airAmbulanceAdapter';
